interface Props {
    onClick: () => void
    disabled?: boolean
}

const EditButton = (props: Props) => {
    return <button
        onClick={props.onClick}
        disabled={props.disabled}
        className="px-3 py-1 text-sm bg-gray-300 text-white rounded hover:bg-gray-600 disabled:opacity-50"
    >✍</button>
}

export default EditButton